"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var base_1 = __importDefault(require("@emotion/styled/base"));
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var react_1 = __importStar(require("react"));
var gatsby_1 = require("gatsby");
var react_2 = require("@emotion/react");
var StyledNav = base_1.default("nav", {
    target: "e12q81ev0",
    label: "StyledNav"
})(process.env.NODE_ENV === "production" ? {
    name: "1hk8cyt",
    styles: "display:flex;flex-wrap:wrap;justify-content:flex-start;padding:7rem 0 var(--gutter-medium);@media(max-width: 1230px){flex-direction:column;}a{color:inherit;text-decoration:underline;margin-bottom:var(--gutter-small);&:not(:last-child){margin-right:var(--gutter-medium);}}"
} : {
    name: "1hk8cyt",
    styles: "display:flex;flex-wrap:wrap;justify-content:flex-start;padding:7rem 0 var(--gutter-medium);@media(max-width: 1230px){flex-direction:column;}a{color:inherit;text-decoration:underline;margin-bottom:var(--gutter-small);&:not(:last-child){margin-right:var(--gutter-medium);}}",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
var Nav = function Nav() {
    var _useState = react_1.useState([]), navItems = _useState[0], setNavItems = _useState[1];
    react_1.useEffect(function () {
        var categories = document.querySelectorAll('span[id]'); // @ts-ignore
        var items = [];
        Array.from(categories).map(function (cat) {
            items.push({
                title: cat.textContent,
                href: cat.getAttribute("id")
            });
        }); // @ts-ignore
        setNavItems(items);
    }, []);
    return react_2.jsx("div", {
        className: "row"
    }, react_2.jsx(StyledNav, null, !navItems.length ? react_2.jsx(react_1.default.Fragment, null, react_2.jsx(gatsby_1.Link, {
        to: "/#solo"
    }, "Solo Exhibitions"), react_2.jsx(gatsby_1.Link, {
        to: "/#group"
    }, "Group Exhibitions"), react_2.jsx(gatsby_1.Link, {
        to: "/#film"
    }, "Film Festivals, Screenings"), react_2.jsx(gatsby_1.Link, {
        to: "/#applied"
    }, "Applied Art Projects"), react_2.jsx(gatsby_1.Link, {
        to: "/#performance"
    }, "Performance"), react_2.jsx(gatsby_1.Link, {
        to: "/#lecture"
    }, "Lecture, Conference"), react_2.jsx(gatsby_1.Link, {
        to: "/#selected-bio"
    }, "Selected Bibliography")) : navItems.map(function (n, i) {
        return react_2.jsx(gatsby_1.Link, {
            to: "/#" + n.href
        }, n.title);
    }), react_2.jsx("a", {
        href: "https://archiv.dabernig.net/",
        target: "_blank"
    }, "Archive"), react_2.jsx(gatsby_1.Link, {
        to: "/contact"
    }, "Contact")));
};
exports.default = Nav;
